import { createPortal } from 'react-dom'
import {
  CHECKOUT_PLACING_COPY,
  CHECKOUT_PLACING_PHASE,
  CHECKOUT_PLACING_STEPS,
  type CheckoutPlacingProps,
} from '../constants/orders'
import { cx } from '../helpers/format'
import '../styles/checkout-dialog.scss'

export function CheckoutPlacing({ phase, online }: CheckoutPlacingProps) {
  const copy = CHECKOUT_PLACING_COPY[phase]
  const steps = online
    ? CHECKOUT_PLACING_STEPS
    : CHECKOUT_PLACING_STEPS.filter((step) => step.id === CHECKOUT_PLACING_PHASE.saving)
  const activeIndex = CHECKOUT_PLACING_STEPS.findIndex((step) => step.id === phase)

  return createPortal(
    <div
      className="checkout-placing"
      role="dialog"
      aria-modal="true"
      aria-labelledby="checkout-placing-title"
      aria-describedby="checkout-placing-lead"
    >
      <div className="checkout-placing__backdrop" />
      <div className="checkout-placing__panel">
        <div className="checkout-placing__stage" aria-hidden>
          <span className="checkout-placing__ring" />
          <span className="checkout-placing__ring checkout-placing__ring--late" />
          <span className="checkout-placing__core" />
        </div>
        <h2 id="checkout-placing-title">{copy.title}</h2>
        <p id="checkout-placing-lead" aria-live="polite">
          {copy.lead}
        </p>
        <ol className="checkout-placing__steps">
          {steps.map((step) => {
            const index = CHECKOUT_PLACING_STEPS.findIndex((item) => item.id === step.id)
            const done = index < activeIndex
            const active = index === activeIndex
            return (
              <li key={step.id} className={cx(done && 'is-done', active && 'is-active')}>
                <span className="checkout-placing__dot" aria-hidden />
                {step.label}
              </li>
            )
          })}
        </ol>
      </div>
    </div>,
    document.body,
  )
}
